export default Object.freeze({
	// Full Address Verified.
	V100: 'V100',

	// Street Address, City, State/Province, and Postal Code are valid, but a suite or apt number may be missing.
	V200: 'V200',

	// “To Country Verified.”
	V300: 'V300',

	// Street, City, State/Province, and Postal Code are valid, but the Street Number could not be verified.
	P100: 'P100',

	// City, State/Province, and Postal Code are valid, but the Street could not be verified.
	P200: 'P200',

	// The City could not be verified
	P300: 'P300',

	// The State/Province could not be verified.
	P400: 'P400',

	// City, State/Province, or Postal Code is invalid.
	P500: 'P500',

	// State/Province and Postal Code are valid, but City and Street could not be verified.
	P600: 'P600',

	// The Address provided could not be verified.
	E100: 'E100',
});
